import { memo } from 'react';
import { Text } from '@chakra-ui/react';

const LabelText = ({ value, label }) => (
  <Text
    pos="absolute"
    top={{ mobile: '-18px', laptop: '-21px' }}
    overflow="hidden"
    transition="opacity .2s,transform .2s"
    noOfLines={1}
    zIndex="0"
    ps="15px"
    textStyle="tag"
    fontWeight="400"
    opacity={value.length ? 0.56 : 0}
    transform={value.length ? 'translateX(0px)' : 'translateX(10px)'}
    color="text.black"
  >
    {label}
  </Text>
);

export default memo(LabelText);
